import { Alert, Box, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { ITeamWorkingHours } from '../../Models/CareTeams/TeamWorkingHours.model';
import { formatWorkingDay } from '../../utils/teamWorkingHoursHelper';

interface TeamWorkingHoursDisplayProps {
    workingHours?: ITeamWorkingHours;
}

const TeamWorkingHoursDisplay: React.FC<TeamWorkingHoursDisplayProps> = ({ workingHours }) => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    if (!workingHours) {
        return <Alert severity="info">Working hours have not been set for this team.</Alert>;
    }

    return (
        <Box>
            <Alert severity="info" sx={{ mb: 2 }}>
                All times are local to the team's meeting address
            </Alert>
            <Grid container spacing={2}>
                {days.map((day) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={day}>
                        <Paper variant="outlined" sx={{ p: 2 }}>
                            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                                {day}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {formatWorkingDay(workingHours[day as keyof ITeamWorkingHours])}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default TeamWorkingHoursDisplay;
